<!--设备 充电枪-->
<template>
    <div>
        <!-- multipleAddTitle="添加多把枪"
            @multipleAdd="multipleAdd" -->
        <top-bar
            :height="'48vh'"
            title="充电枪"
            addTitle="添加单把枪"
            :loading="loading"
            :selectSite="selectSite"
            :pileId="pileId"
            :isSite="isSite"
            :multiple="true"
            :showSelectPile="true"
            :isShowRefresh="true"
            :reset="true"
            ref="topBar"
            multipleAddTitle="添加多把枪"
            @multipleAdd="multipleAdd"
            @refresh="refresh"
            @add="add"
            @chooseSite="chooseSite"
            @choosePile="choosePile"
            @back="back"
            @search="search"
            @resetConnector="resetConnector"
        />
        <v-container fluid class="mt-n6">
            <v-card outlined :color="theme.elementBgColor" class="pa-2">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane v-for="(tab, index) in tabs" :key="index" :name="tab.name">
                        <span
                            slot="label"
                            :style="{
                                color: activeName === tab.name ? '#4dabf7' : theme.pageFontColor,
                            }"
                        >
                            {{ tab.value }}（{{ showNum(tab.name) }}）
                        </span>
                        <div
                            class="gun-main"
                            :style="{ backgroundColor: theme.pageBgColor }"
                            v-loading="loading"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255,252,252, 0.8)"
                        >
                            <v-img
                                v-if="no_data"
                                width="100%"
                                height="100%"
                                src="@/assets/no_data.svg"
                            ></v-img>
                            <div class="gun-div" v-for="(item, index) in gunInfo" :key="index">
                                <div
                                    class="gun-info"
                                    :style="{ backgroundColor: theme.titleFontColor }"
                                    @mouseenter="enter(item.id)"
                                    @mouseleave="item.overlay = false"
                                    @click="toDetails(item)"
                                >
                                    <div class="gun-name-div">
                                        <div
                                            class="gun-name"
                                            :style="{ backgroundColor: showColor(item.status) }"
                                        >
                                            名称：{{ item.name }}
                                        </div>
                                    </div>
                                    <div class="gun-main-info">
                                        <div class="gun-icon">
                                            <charging v-if="tab.name === '2'" />
                                            <i
                                                v-else
                                                class="iconfont icon-chongdianqiang1"
                                                :style="{
                                                    fontSize: '4rem',
                                                    color: showColor(item.status),
                                                }"
                                            ></i>
                                        </div>
                                        <div class="gun-tag">
                                            <div class="_tag">
                                                {{ showText("Soc") }}：{{ item.Soc }}
                                            </div>
                                            <div class="_tag">
                                                {{ showText("CurrentA") }}：{{ item.CurrentA }}
                                            </div>
                                            <div class="_tag">
                                                {{ showText("VoltageA") }}：{{ item.VoltageA }}
                                            </div>
                                            <div class="_tag">
                                                {{ showText("Temperature") }}：{{
                                                    item.Temperature
                                                }}
                                            </div>
                                            <div class="_tag">模式：{{ model(item.type) }}</div>
                                        </div>
                                    </div>
                                    <v-overlay
                                        :absolute="item.absolute"
                                        :value="item.overlay"
                                        opacity="0.4"
                                    >
                                        <div class="overlay-font">{{ item.connector_id }}</div>
                                        <div class="overlay-font">{{ item.updatetime }}</div>
                                        <i class="iconfont icon-dianji  ml-15"></i>
                                    </v-overlay>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </v-card>
            <v-card
                height="2.2em"
                class="mt-6"
                color="#EFF1F7"
                outlined
                style="border-radius: 1.8em;"
            >
                <el-pagination
                    background
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="total"
                    :current-page="newPage"
                    class="float-right"
                    @current-change="pageChange"
                ></el-pagination>
            </v-card>
        </v-container>
        <v-dialog scrollable v-model="isAdd" v-if="isAdd" width="55rem" overlay-color="#262626">
            <connector-form
                :isAdd="isAdd"
                :isEdit="false"
                v-if="isSite"
                :station_id="selectSite"
                @cancel="cancel"
                @refresh="refresh"
            />
        </v-dialog>
        <v-dialog
            scrollable
            v-model="isMultipleAdd"
            v-if="isMultipleAdd"
            width="55rem"
            overlay-color="#262626"
        >
            <more-connector-form
                v-if="isSite"
                :station_id="selectSite"
                @cancel="cancel"
                @refresh="refresh"
            />
        </v-dialog>
        <el-button type="primary" @click="get(false)">获取所有充电枪数据</el-button>
        <el-button type="primary" @click="get(true)">获取当前站点充电枪数据</el-button>
        <download-excel
            class = "export-excel-wrapper"
            :data = "json_data"
            :fields = "json_fields"
            title="站点的所有充电枪数据"
            name = "充电枪数据.xls">
            <el-button type="primary">导出所有枪数据为EXCEL</el-button>
        </download-excel>
    </div>
</template>
<script>
import util from "@/util";
import store from "@/store";
import Public from "@/public";
import Charging from "@/components/Charging";
import SelectSite from "@/components/SelectSite";
import SelectPile from "@/components/SelectPile";
import TopBar from "@/components/TopBar";
import ConnectorForm from "@/components/Form/ConnectorForm";
import MoreConnectorForm from "@/components/Form/MoreConnectorForm";
import { mapState } from "vuex";
export default {
    name: "ChargingGun",
    data() {
        return {
            json_fields: {
                "站点ID": "station_id",
                "站点名称": "station_name",
                "桩ID": "equipment_id",
                "枪ID": "connector_id", 
                "枪名称": "name",
                "枪额定功率": "power",
                "电流": "current",
                "电压上限": "v_upper",
                "电压下限": "v_lower",
                "桩类型": "type_text"
            },
            json_data:[],    //导出表格数据
            json_meta: [
              [
                {
                  " key ": " charset ",
                  " value ": " utf- 8 "
                }
              ]
            ],
            
            activeName: "2",
            loading: false,
            no_data: true,
            selectSite: null, //选中的站点
            selectSiteName: null, //选中的站点名称
            cecName: null, //选中的站点互联互通公司名称
            isAdd: false, //打开添加枪弹框
            isMultipleAdd: false, //打开添加多把枪弹框
            isSite: true,
            pageSize: 10, //一页显示的数据数
            total: 0,
            gunInfos: null, //查询所有属于这个站点的充电枪数据
            gunInfo: null, //这个站点中所有在这个状态下的数据
            newPage: 1, //当前页
            info: [
                {
                    id: "Soc",
                    text: "Soc(%)",
                },
                {
                    id: "CurrentA",
                    text: "电流(A)",
                },
                {
                    id: "VoltageA",
                    text: "电压(V)",
                },
                {
                    id: "Temperature",
                    text: "温度(℃)",
                },
            ],
            nums: {
                charging: 0,
                free: 0,
                offline: 0,
                fault: 0,
            },
            pileData: null, //选择充电桩后属于这些充电桩的数据
            pileId: [],
            isPile: false, //是否选择了充电桩
            isCec: false, //是否是互联互通站点
            timer: null, //定时器
            isClickBack: true, //是否点击了返回上一页
            theStateGun: [],  //所有当前状态的枪数据
            typeText: [
                {
                    id: 1,
                    value: "家用插座",
                },
                {
                    id: 2,
                    value: "交流插座",
                },
                {
                    id: 3,
                    value: "交流桩",
                },
                {
                    id: 4,
                    value: "直流桩",
                },
                {
                    id: 5,
                    value: "无线",
                },
                {
                    id: 6,
                    value: "其他",
                },
            ],
            statusText: [
                {
                    id: 1,
                    value: "空闲",
                },
                {
                    id: 0,
                    value: "离线",
                },
                {
                    id: 254,
                    value: "冻结",
                },
                {
                    id: 255,
                    value: "故障",
                },
            ],
            tabs: [
                { name: "2", value: "占用" },
                { name: "1", value: "空闲" },
                { name: "0", value: "离线" },
                { name: "254", value: "故障" },
            ],
        };
    },
    watch: {
        selectSite: {
            handler(val) {
                this.isSite = false;
                this.$nextTick(() => {
                    this.isSite = true;
                });
                this.refresh();
            },
        },
        siteList: {
            handler(val) {
                let data = JSON.parse(JSON.stringify(val));
                this.selectSite = data[0].children[0].id;
            },
        },
        gunInfo: {
            handler(val) {
                if (val.length == 0) {
                    this.no_data = true;
                } else {
                    this.no_data = false;
                }
            },
            deep: true,
        },
    },
    computed: {
        ...mapState([
            "siteList",
            "connectorInfo",
            "connectorStatusInfo",
            "isJump",
            "toGunSiteId",
            "toPileId",
            "theme",
            "contactInfo",
            "resetConnectorResults"
        ]),
    },
    mounted() {
        if (
            (this.$route.params.status || this.$route.params.status == 0) &&
            this.isJump &&
            this.toGunSiteId
        ) {
            //从站点页面跳转进入此页面
            this.selectSite = this.toGunSiteId;
            this.activeName = String(this.$route.params.status);
        } else if (
            !this.isJump &&
            !this.toGunSiteId &&
            !this.$route.params.status &&
            !this.toPileId &&
            this.siteList[0]
        ) {
            this.selectSite = this.siteList[0].children[0].id;
        }
    },
    components: {
        SelectSite,
        SelectPile,
        Charging,
        TopBar,
        ConnectorForm,
        MoreConnectorForm,
    },
    methods: {
        //重置当前状态下的所有枪
        resetConnector() {
            let tabName = "";
            for(let i = 0;i<this.tabs.length;i++) {
                if(this.activeName == this.tabs[i].name) {
                    tabName = this.tabs[i].value
                }
            }
            this.$confirm('此操作将重置'+this.selectSiteName+'下的'+this.theStateGun.length+'把'+tabName+'的枪, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.resetConnectorFun()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消重置'
                });          
            });
        },
        //批量重置
        async resetConnectorFun() {
            const loading = this.$loading({
                lock: true,
                text: '重置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let stateGun = this.JsonData(this.theStateGun)
            console.log(stateGun)
            let promiseArr = [];
            for (let i = 0; i < stateGun.length; i++) {
                let postData = {
                    connector_id: stateGun[i].connector_id,
                };
                await store.dispatch("resetConnectors", postData);
                let promise = new Promise((resolve, reject) => {
                    // console.log(this.resetConnectorResults)
                    resolve(this.resetConnectorResults);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    loading.close();
                    util.ShowTip("总共重置成功"+result.length+"把枪", 1);
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        //获取所有充电枪数据
        async get(isAll) {
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let site = this.JsonData(this.siteList)
            console.log(site)
            let allsite = []
            for(let i = 0;i<site.length;i++) {
                for(let j = 0;j<site[i].children.length;j++) {
                    if(isAll) {
                        if(this.selectSite == site[i].children[j].id)  {  //是否导出当前站点的枪数据
                            allsite.push({
                                station_id: site[i].children[j].id,
                                station_name: site[i].children[j].value
                            })
                        }
                    }else {
                        allsite.push({
                            station_id: site[i].children[j].id,
                            station_name: site[i].children[j].value
                        })
                    }
                }
            }
            console.log(allsite)
            let promiseArr = [];
            for (let i = 0; i < allsite.length; i++) {
                let postData = {
                    station_id: allsite[i].station_id,
                };
                await store.dispatch("getConnector", postData);
                let promise = new Promise((resolve, reject) => {
                    let data = this.JsonData(this.connectorInfo)
                    for(let j = 0;j<data.length;j++) {
                        data[j].station_id = allsite[i].station_id
                    }
                    resolve(data);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    let info = []
                    for(let i = 0;i<result.length;i++) {
                        for(let j =0;j<result[i].value.length;j++) {
                            info.push(result[i].value[j])
                        }
                    }
                    for(let a = 0;a<info.length;a++) {
                        info[a].connector_id = info[a].connector_id + '&nbsp;'
                        info[a].name = info[a].name + '&nbsp;'
                        if(info[a].type == 1) {
                            info[a].type_text = "家用插座"
                        }else if(info[a].type == 2) {
                            info[a].type_text = "交流接口插座"
                        }else if(info[a].type == 3) {
                            info[a].type_text = "交流接口插头"
                        }else if(info[a].type == 4) {
                            info[a].type_text = "直流接口枪头"
                        }
                        else if(info[a].type == 5) {
                            info[a].type_text = "无线充电座"
                        }
                        else if(info[a].type == 6) {
                            info[a].type_text = "其他"
                        }
                    }
                    for(let i = 0;i<allsite.length;i++) {
                        for(let j = 0;j<info.length;j++) {
                            if(allsite[i].station_id == info[j].station_id) {
                                info[j].station_name = allsite[i].station_name
                            }
                        }
                    }
                    console.log(info)
                    this.json_data = info;
                    loading.close();
                    util.ShowTip("总共获取到"+info.length+"条数据", 1);
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        /*搜索*/
        async search(reg) {
            let dataArr = [];
            let str = reg.toString().substring(1, reg.toString().length - 2);
            for (let i = 0; i < this.gunInfos.length; i++) {
                if (
                    this.gunInfos[i].connector_id.search(str) != -1 ||
                    this.gunInfos[i].name.search(str) != -1
                ) {
                    dataArr.push(this.gunInfos[i]);
                }
            }
            this.classification(1, dataArr);
            if (dataArr.length == 0) {
                util.ShowTip("未查找到相关数据", 2);
                await this.refresh();
                return;
            }
            util.ShowTip("查询到" + dataArr.length + "条数据", 1);
        },
        refresh() {
            this.getGunData(this.newPage);
        },
        /*导航条切换*/
        handleClick(tab) {
            this.activeName = tab.name;
            this.newPage = 1;
            if (this.pileId.length != 0) {
                this.classification(1, this.pileData);
            } else {
                this.classification(this.newPage, this.gunInfos);
            }
        },
        /*分页切换*/
        pageChange(page) {
            if (page == undefined) {
                page = 1;
            }
            this.newPage = page;
            if (this.pileId.length != 0 && this.isPile == false) {
                //选择了充电桩
                this.classification(this.newPage, this.pileData);
            } else if (this.pileId == null && this.isPile == true) {
                //选择了充电桩后并清空
                this.classification(this.newPage, this.gunInfos);
            } else {
                this.classification(this.newPage, this.gunInfos);
            }
        },
        /*获取充电枪数据*/
        async getGunData(page) {
            this.loading = true;
            if (!this.selectSite) {
                this.loading = false;
            } else {
                let postData = {
                    station_id: this.selectSite,
                };
                await store.dispatch("getConnector", postData);
                this.gunInfos = JSON.parse(JSON.stringify(this.connectorInfo.reverse()));
                this.gunInfos.sort(Public.createComprisonFunction("connector_id"));
                if (!this.pileId.length != 0) {
                    this.classification(page, this.gunInfos);
                } else {
                    this.choosePile(this.pileId);
                }
                this.loading = false;
            }
        },
        /*获取充电枪实时状态信息*/
        async getConnStatus(postData) {
            await store.dispatch("getConnectorStatus", postData);
            let gunData = JSON.parse(JSON.stringify(this.gunInfo));
            for (let i = 0; i < this.connectorStatusInfo.length; i++) {
                if (gunData[i].connector_id == this.connectorStatusInfo[i].ConnectorID) {
                    gunData[i].Soc = this.connectorStatusInfo[i].Soc;
                    gunData[i].CurrentA = this.connectorStatusInfo[i].CurrentA;
                    gunData[i].VoltageA = this.connectorStatusInfo[i].VoltageA;
                    gunData[i].Temperature = this.connectorStatusInfo[i].Temperature;
                }
            }
            this.gunInfo = JSON.parse(JSON.stringify(gunData));
        },
        /*添加设备*/
        add() {
            this.isAdd = true;
        },
        /*添加多个枪*/
        multipleAdd() {
            this.isMultipleAdd = true;
        },
        /*取消添加*/
        cancel() {
            this.isAdd = false;
            this.isMultipleAdd = false;
        },
        /*返回*/
        back() {
            this.isClickBack = false;
        },
        /*充电枪状态分类*/
        classification(page, datas) {
            clearInterval(this.timer);
            if (!datas) {
                return;
            } else {
                let data = JSON.parse(JSON.stringify(datas));
                this.nums.charging = 0;
                this.nums.free = 0;
                this.nums.offline = 0;
                this.nums.fault = 0;
                let allData = [];
                for (let i = 0; i < datas.length; i++) {
                    if (datas[i].status == 2) {
                        this.nums.charging += 1;
                    }
                    if (datas[i].status == 1) {
                        this.nums.free += 1;
                    }
                    if (datas[i].status == 0) {
                        this.nums.offline += 1;
                    }
                    if (datas[i].status == 255 || datas[i].status == 254) {
                        this.nums.fault += 1;
                    }
                    if (Number(this.activeName) == datas[i].status) {
                        datas[i].absolute = true;
                        datas[i].overlay = false;
                        allData.push(datas[i]);
                    }
                    if (this.activeName == "254" && datas[i].status == 255) {
                        datas[i].absolute = true;
                        datas[i].overlay = false;
                        allData.push(datas[i]);
                    }
                }
                this.total = allData.length;
                this.theStateGun = allData;
                console.log(this.theStateGun)
                let gunData = allData.slice((page - 1) * this.pageSize, page * this.pageSize);
                this.gunInfo = JSON.parse(JSON.stringify(gunData));
                let postData = {
                    ConnectorIDs: [],
                };
                for (let i = 0; i < this.gunInfo.length; i++) {
                    postData.ConnectorIDs.push(this.gunInfo[i].connector_id);
                }
                this.getConnStatus(postData);
                if (postData.ConnectorIDs.length > 0) {
                    this.timer = setInterval(() => {
                        this.getConnStatus(postData);
                    }, 6000);
                }
            }
        },
        /*下拉框选择站点*/
        chooseSite(site) {
            this.pileId = [];
            this.$refs.topBar.$refs.selectPile = null;
            this.selectSite = site["siteId"];
            this.selectSiteName = site["siteName"];
            this.cecName = site["cecName"];
            if (this.isJump) {
                store.commit("SET_PILE_ID", site.siteId);
            }
        },
        /*下拉框选择充电桩*/
        choosePile(pile) {
            this.pileId = pile;
            if (pile.length === 0) {
                this.refresh();
                return;
            }
            this.newPage = 1;
            let allData = JSON.parse(JSON.stringify(this.gunInfos));
            if (pile.length === 0) {
                //多选充电桩，没有选
                this.isPile = true;
                this.classification(1, this.gunInfos);
            } else if (pile.length !== 0) {
                //多选充电桩，选择
                this.isPile = false;
                let datas = [];
                for (let j = 0; j < pile.length; j++) {
                    for (let i = 0; i < allData.length; i++) {
                        if (allData[i].equipment_id == pile[j]) {
                            datas.push(allData[i]);
                        }
                    }
                }
                this.pileData = JSON.parse(JSON.stringify(datas.reverse()));
                this.classification(1, this.pileData);
            }
        },
        toDetails(gunData) {
            this.isClickBack = true;
            this.$router.push({
                name: "GunDetails",
            });
            gunData["selectSite"] = this.selectSite;
            gunData["siteName"] = this.selectSiteName;
            gunData["cecName"] = this.cecName;
            store.commit("SET_GUN_DETAIL", gunData);
            // store.commit("SET_SHOW_NAVIGATION", false);
        },
        /*鼠标移入*/
        enter(id) {
            for (let i = 0; i < this.gunInfo.length; i++) {
                this.gunInfo[i].overlay = false;
                if (this.gunInfo[i].id == id) {
                    this.gunInfo[i].overlay = true;
                }
            }
        },
        handleClose(done) {},
        showColor(e) {
            if (e == 2) {
                return "#74c0fc";
            }
            if (e == 1) {
                return "#95de64";
            }
            if (e == 0) {
                return "#ced4da";
            }
            if (e == 255 || 254) {
                return "#fa5252";
            }
        },
        showText(e) {
            let value = "";
            this.info.forEach((val, index) => {
                if (e == val.id) {
                    value = val.text;
                }
            });
            return value;
        },
        showNum(e) {
            let num;
            if (e === "2") {
                num = this.nums.charging;
            } else if (e === "0") {
                num = this.nums.offline;
            } else if (e == "1") {
                num = this.nums.free;
            } else if (e === "254") {
                num = this.nums.fault;
            }
            return num;
        },
        /*模式*/
        model(type) {
            let text = "";
            this.typeText.forEach((val, index) => {
                if (val.id == type) {
                    text = val.value;
                }
            });
            return text;
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.timer);
        if (to.path !== "/devices/details" && !this.isClickBack) {
            from.meta.keepAlive = false;
            store.commit("SET_ISJUMP", false);
            store.commit("SET_PILE_ID", null);
            store.commit("SET_GUN_SITE_ID", null);
        }
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (
                //从充电桩页面跳转 （进入详情页） 接着返回
                vm.isJump &&
                vm.toGunSiteId &&
                vm.toPileId
            ) {
                vm.pileId = [];
                vm.selectSite = vm.toGunSiteId;
                vm.pileId.push(vm.toPileId);
            } else if (vm.toGunSiteId && !vm.toPileId) {
                //从充电站页面跳转后 进入详情页 （接着返回）
                vm.selectSite = vm.toGunSiteId;
            }
        });
    },
};
</script>

<style scoped>
@import "../../assets/css/chargingGun.css";
/* ._tag {
    width: 7vw;
    height: 1.5vw;
    font-size: 0.5vw;
    background: #fff;
    border: 1px solid #909399;
    color: #909399;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.5vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
} */
._tag:nth-child(n + 2) {
    margin-top: 0.3vw;
}
.overlay-font {
    font-size: 1.1vw;
}
</style>
